//系统路由

export default {

    /* 404页面 */
    '404': resolve => require(['../common/404.vue'], resolve)
}




// WEBPACK FOOTER //
// ./src/routes/system.js